<template>
  <div v-if="taskItem" class="taskItemWrapper">
    <div class="flex-between-center f24 blue" style="margin-bottom: .5em;">
      <div class="flex-center">
        <div class="taskIndex tagItem">{{ String(index + 1).padStart(2, 0) }}</div>
        <div v-if="taskItem.required" class="requiredTag tagItem">*必填</div>
        <div v-if="taskItem.tags" class="tags tagItem ellipsis">
          {{ taskItem.tags }}
        </div>
      </div>
      <div class="flex-center">
        <el-popover v-if="taskItem.lastLoseItemId" placement="left-end" width="650" v-loading="lastLoseLoading">
          <TirDetail :tir="lastLoseItem" />
          <div slot="reference" class="cursor-pointer" @click="goLastLoss">
            <span>上次失分项</span>
          </div>
        </el-popover>
        <el-popover v-if="hasStandard" placement="bottom-end" width="450">
          <div>
            <p style="margin: 10px;">{{ taskItem.refStandard }}</p>
            <GalleryBox class="mar-20-10" :attaList="attaList"/>
          </div>
          <div slot="reference" class="cursor-pointer">
            <span v-if="taskItem.lastLoseItemId">｜</span>
            <span>参考标准</span>
          </div>
        </el-popover>
      </div>
    </div>
    <div
      class="f32 textj black fwb"
      :class="{ ellipsis2: !showMore }"
      @click="changeShowMore"
    >
      {{ taskItem.describle }}
    </div>
    <div class="optionWrap f28 black2">
      <div v-if="taskItem.naType && taskItem.type!=8"
        class="optBtn"
        :class="{checked: taskItem.phoneIsNa==1}"
        @click="changeItem('NA',taskItem)"
      >N/A</div>      
      <template v-if="[1,2,3].includes(taskItem.type)">
        <div
            v-for="(item,i) in taskItem.options"
            :key="i"
            class="optBtn ellipsis"
            :class="{checked: executable && item.state==1}"
            @click="changeItem(taskItem.type,taskItem,i)"
        >{{ item.name }}
        </div>
      </template>
      <template v-if="taskItem.type == 4">
        <input
            :placeholder="`请输入${taskItem.inputNumericalType === 1 ? '整数' : '数值'}(最大值: ${fullScore})`"
            class="input"
            type="number"
            maxlength="500"
            :value="taskItem.result"
            @input="changeNumber"
            @blur="changeItem(4,taskItem,$event.target.value)"
        />
      </template>
      <template v-if="taskItem.type == 5">
        <input
          class="input"
          type="text"
          maxlength="500"
          :value="taskItem.result"
          @blur="changeItem(5,taskItem,$event.target.value)"
        />
      </template>
      <template v-if="taskItem.type == 6">
        <textarea
          class="input textarea"
          :value="taskItem.result"
          maxlength="2000"
          @blur="changeItem(6,taskItem,$event.target.value)"
        />
      </template>
      <template v-if="taskItem.type == 8">
        <div class="pad-t-half">
          <span class="f28 black mr10">选择时间:</span>
          <template v-if="executable">
            <el-date-picker class="input-inner-height-24"
              v-model="taskItem.result"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="请选择日期时间"
              @change="changeItem(8,taskItem,$event)">
            </el-date-picker>
          </template>
          <template v-else>
            <span class="f28 grey mr10">请选择时间</span>
            <img class="icon-14 text_center" :src="arrow"/>
          </template>
        </div>
      </template>

    </div>
    <div class="flex-between remarks">
      <div class="flex-between goComent">
        <div class="posr cursor-pointer" @click="goComment(taskItem)" v-if="taskItem.isShowRemark==1">
          <img class="icon" :src="remarks" />
          <span class="sTitle">备注</span>
          <div v-if="taskItem.comment" class="dot"></div>
        </div>
        <div class="posr cursor-pointer" @click="goMedia(taskItem)" v-if="taskItem.isShowMedia==1">
          <img class="icon" :src="media" />
          <span class="sTitle">媒体</span>
          <div v-if="taskItem.hasMedia" class="dot"></div>
        </div>
      </div>
      <div v-if="corLimit" class="posr" @click="goCorrect(taskItem)" :style="{ cursor: corLimit===1 ? 'pointer' : 'not-allowed' }">
        <img class="icon" :src="toCorrect" />
        <span class="sTitle">整改</span>
        <div v-if="taskItem.hasCorrect" class="dot"></div>
      </div>
    </div>
  </div>
</template>
<script>
import GalleryBox from '../../../components/GalleryBox'
import TirDetail from '../../DetailPages/details/components/TirDetail.vue';
import { getLastLoseItem } from '../../../api/request'
export default {
  props: ["taskItem", "index", "type", "corLimit"],
  components: {
    GalleryBox,
    TirDetail
  },
  data() {
    return {
      remarks: require("../../../assets/image/task/remarks.png"),
      media: require("../../../assets/image/task/media.png"),
      alert: require("../../../assets/image/task/alert.svg"),
      toCorrect: require("../../../assets/image/task/toCorrect.png"),
      arrow: require("../../../assets/image/arrow-down-grey.png"),
      showMore: false,
      attaIndex: null,
      lastLoseItem: {},
      lastLoseLoading: false
    };
  },
  computed: {
    hasStandard() {
      return !!(
        this.taskItem?.refStandard ||
        this.taskItem?.appendixes?.length ||
        this.taskItem?.videoAppendixes?.length
      );
    },
    attaList() {
      const files = []
      function pushAttaList(appendixes) {
        Array.isArray(appendixes) && appendixes.forEach(a =>
          files.push({ src: a.url, thumb: a.thumbnail, type: a.type })
        )
      }
      pushAttaList(this.taskItem?.appendixes)
      pushAttaList(this.taskItem?.videoAppendixes)
      return files;
    },
    fullScore() {
      let fullScoreNumerical = Number(this.taskItem?.fullScore);
      return fullScoreNumerical < 0 ? -fullScoreNumerical : fullScoreNumerical;
    },
    executable() {
      return Number.isInteger(this.corLimit);
    }
  },
  methods: {
    changeShowMore() {
      this.showMore = true;
    },
    // 任务项类型：1对错型 2单选型 3多选型 4输入数值 5输入单行文本 6输入多行文本 8日期时间 9图片
    changeItem(type, tir, val) {
      //console.log(`changeItem of type ${type}, val = ${val}`);
      tir.state = 1;
      if (type == "NA") {
        if (tir.phoneIsNa == 0) {
          tir.phoneIsNa = 1;
          tir.score = 0;
          tir.result = "";
          if (Array.isArray(tir.options)) {
            tir.options.forEach((item) => {
              item.state = 0;
            });
          }
        } else if (tir.phoneIsNa == 1) {
          tir.phoneIsNa = 0;
          tir.score = this.fullScore;
          //tir.state = 0;
        }
      } else if (type == 1 || type == 2) {
        if (tir.options[val].state == 1) {
          return;
        }
        tir.options.forEach((item, index) => {
          if (index == val) {
            tir.score = item.score;
            item.state = 1;
          } else {
            item.state = 0;
          }
        });
        tir.phoneIsNa = 0;
      } else if (type == 3) {
        tir.score = 0;
        let selected = false;
        tir.options.forEach((item, index) => {
          if (index == val) {
            item.state = item.state ? 0 : 1;
          }
          if (item.state == 1) {
            selected = true;
            tir.score += 1 * item.score;
          }
        });
        if (!selected) {
          tir.score = this.fullScore;
          //tir.state = 0;
        }
        tir.phoneIsNa = 0;
      } else if (type == 4) {
        tir.phoneIsNa = 0;
        if (val === undefined || Number(val) > this.fullScore) {
          tir.result = this.fullScore.toString();
          tir.score = this.fullScore;
        } else {
          tir.result = val;
          tir.score = val;
        }
        if (!val) {
          //tir.state = 0;
        }
      } else if (type == 5 || type == 6) {
        tir.result = val;
        tir.score = this.fullScore;
        if (!val) {
          //tir.state = 0;
        }
      } else if (type == 8) {
        tir.score = this.fullScore;
        if (!val) {
          //tir.state = 0;
        }
      }
      this.executable && this.$emit("changeItem", tir);
    },
    goComment(tir) {
      this.executable && this.$emit("showDialogue", tir, 1);
    },
    goMedia(tir) {
      this.executable && this.$emit("showDialogue", tir, 2);
    },
    goCorrect(tir) {
      if (this.corLimit === 1) {
        this.$emit("showDialogue", tir, 3);
        // 保存离开页面的滚动值
        // this.$store.commit("task/SCROLL_TOP", document.documentElement.scrollTop || document.body.scrollTop);
        // this.$store.commit("task/SET_CUR_TASK_ITEM", this.taskItem);
        // window.localStorage.setItem('CUR_TASK_ITEM', JSON.stringify(this.taskItem));
        // this.$router.push(`/createRectification/${this.taskItem.id}?taskRecordId=${this.taskItem.taskRecordId}`);
      }
    },
    changeNumber(e) {
      if (e.target.value == "00") {
        e.target.value = "0";
      }
      if (this.taskItem.inputNumericalType === 2) {
        if (e.target.value.startsWith('.')) {
          e.target.value = `0${e.target.value}`
        }
      } else if (this.taskItem.inputNumericalType ===1) {
        e.target.value = e.target.value.match(/^\d*/g)[0] || "";
      }
      if (1 * Number(e.target.value) > 1 * this.fullScore) {
        e.target.value = this.fullScore;
      }
    },    
    goLastLoss() {
      if (this.executable && !this.lastLoseItem.id) {
        this.lastLoseLoading = true;
        getLastLoseItem(this.taskItem.lastLoseItemId)
          .then(res => {
            if (res.data && res.data.id)
              this.lastLoseItem = res.data;
          })
          .finally(() => this.lastLoseLoading = false)
      }
    },
  },
};
</script>
<style lang="less" scoped>
.taskItemWrapper {
  position: relative;
  border: 1px solid #e3ebff;
  background: #fff;
  border-radius: .5em;
  padding: .8em 1em .8em 1.25rem;
  .tags {
    width: 8.75em;
    height: 1em;
    line-height: 1em;
    // font-size: .8rem;
    font-weight: 400;
  }
  .requiredTag {
    height: 1em;
    line-height: 1em;
    // font-size: .8rem;
    font-weight: 400;
    color: #fa6400;
  }
  .tagItem + .tagItem {
    margin-left: .6em;
  }
  .icon {
    width: 1em;
    height: 1em;
    vertical-align: middle;
  }
  .icon-14 {
    width: .875em;
    height: .875em;
  }
  .sTitle {
    margin-left: .1em;
  }
  .dot {
    position: absolute;
    right: -0.25em;
    top: .25em;
    width: .5em;
    height: .5em;
    border-radius: .25em;
    background: #ff9851;
  }
  .input {
    margin-top: .5em;
    padding: 0 .5em;
    min-width: 50%;
    background: #fff;
    border-radius: .25em;
    border: 1px solid #f4f5f7;
    &:focus {
      border: 1px solid #609fff;
    }
  }

  .taskIndex {
    // position: absolute;
    // left: 0;
    // top: .9em;
    margin-left: -1.25rem;
    height: 1.2em;
    width: 1.5em;
    font-size: .8rem;
    line-height: 1.2em;
    color: #fff;
    text-align: center;
    background: #00cca2;
    font-weight: bold;
    border-radius: 0 .2em .2em 0;
  }
  .remarks {
    margin-top: 1em;
    height: 1.5em;
    line-height: 1.5em;
    font-size: .75rem;
    color: #74879b;
  }
  .optionWrap {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    // align-content: space-around;
    gap: .25em 1em;
  }
  .optBtn {
    display: inline-block;
    box-sizing: border-box;
    padding: 0 .5em;
    margin-top: .5em;
    min-width: 4em;
    max-width: 15em;
    height: 1.5em;
    line-height: 1.5em;
    border: 1px solid #f4f5f7;
    border-radius: .25em;
    text-align: center;
  }

  .checked {
    color: #fff;
    background: #428ff8;
    border: 1px solid #428ff8;
  }

  .goComent {
    width: 7.5em;
  }
}

.f24 {
  font-size: .75rem;
}
.f32 {
  font-size: 1rem;
}
.f28 {
  font-size: .875rem;
}

.textj {
  text-align: justify;
}

.fwb {
  font-weight: bold;
}

textarea {
  box-sizing: border-box;
  resize: none;
  background: none;
  color: inherit;
  opacity: inherit;
  font: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  text-indent: inherit;
  text-transform: inherit;
  text-shadow: inherit;
  white-space: pre-wrap;
  word-break: break-all;
  outline: none;
  border: none;
  padding: 0;
  margin: 0;
  text-decoration: inherit;
}
.textarea {
  // margin: 10px 0 6px 0;
  min-height: 7.5em;
  width: 99%;
}

</style>